var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMineralOccurrence({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_mineral_occurrence)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 4.5C25.9036 4.5 31.5 10.0964 31.5 17C31.5 23.9036 25.9036 29.5 19 29.5C12.0964 29.5 6.5 23.9036 6.5 17C6.5 10.0964 12.0964 4.5 19 4.5Z",
    fill: "#455A64",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9 20.1 L21.3 13.7",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 11.8 L20.8 14.2 L23.2 15.5 L21.9 13.1 Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_mineral_occurrence",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_mineral_occurrence"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_mineral_occurrence",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMineralOccurrence);
export default __webpack_public_path__ + "static/media/mineral_occurrence.11563facfade25f62d2d8c6f01496173.svg";
export { ForwardRef as ReactComponent };